import React, { Component } from 'react'
import logo from "../images/logo.png"
export class Logo extends Component {
  render() {
    return (
      <div className='flex flex-col items-center'>
        <img src={logo} alt="Logo" />
      </div>
    )
  }
}

export default Logo